import React, { useEffect } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import { Spinner } from 'components';
import { getLayout } from 'components/layouts/Header';
import { Page } from 'components/layouts';
import { withAuthCandidate } from 'lib/hocs/withAuthCandidate';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useCandidateMatches } from 'lib/providers/CandidateMatchesProvider';

import styles from './Matches.module.scss';

const CandidateMatches: React.FC = () => {
  const router = useRouter();
  const { opportunityMatches, isMatchesLoading } = useCandidateMatches();

  useEffect(() => {
    if (isMatchesLoading) return;

    const match = opportunityMatches.find((match) => !match.viewed_at);
    if (!match) {
      router.replace(PAGE_ROUTES.CANDIDATE_MATCHES_SEEN_ALL);
      return;
    }

    const route = `${PAGE_ROUTES.CANDIDATE_MATCHES}/${match.matchable_slug}`;
    router.replace(route);
  }, [isMatchesLoading, opportunityMatches]);

  return (
    <>
      <Head>
        <title>Matches | Huzzle</title>
      </Head>
      <Page>
        <Spinner wrapperClassname={styles.spinner} />
      </Page>
    </>
  );
};

const CandidateMatchesWrapper = withAuthCandidate(CandidateMatches);

// @ts-ignore
CandidateMatchesWrapper.getLayout = getLayout;

export default CandidateMatchesWrapper;
